import { create } from "zustand"

interface CryptoConsentModalRequest {
    accessToken: string
    companyId?: string
    cryptoProviderTermsId: number
    onAccepted: () => void
    skipCounter: number
}

interface ICryptoConsentModalStore {
    request: CryptoConsentModalRequest | null
    close: () => void
    open: (request: CryptoConsentModalRequest) => void
}

export const useCryptoConsentModalStore = create<ICryptoConsentModalStore>()((set) => ({
    request: null,
    close: () => set({ request: null }),
    open: (request) => set({ request }),
}))
